// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2ak1Q","question":"Question_question__3vLat","description":"Question_description__14goi"};